import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

/**
 * Kolom isi bergaya Threads: judul pendek di tengah atas, lalu satu kartu
 * putih bersudut atas membulat yang memanjang sampai dasar layar.
 *
 * Di ponsel kartunya dilepas — isinya langsung menempel ke tepi layar,
 * sebab bingkai di layar sesempit itu hanya memakan ruang.
 *
 * Anak-anaknya mendapat jarak tepi sendiri. Yang harus selebar kartu,
 * seperti garis pemisah antarkiriman, memakai margin negatif yang sama
 * (lihat PostCard).
 */
export function Kolom({
  judul,
  children,
  className,
}: {
  /** Teks judul, atau simpul sendiri seperti pengalih tab lini masa. */
  judul: ReactNode
  children: ReactNode
  className?: string
}) {
  return (
    // Margin negatif meniadakan jarak atas dan bawah kerangka aplikasi,
    // supaya kartu menempel ke dasar layar seperti di Threads.
    <div className="-mx-4 -mb-24 -mt-4 sm:-mx-6 md:mx-auto md:w-full md:max-w-[40rem] lg:-mb-10 lg:-mt-8">
      <header className="flex h-14 items-center justify-center text-[15px] font-semibold text-ink">
        {typeof judul === 'string' ? <h1>{judul}</h1> : judul}
      </header>

      <div
        className={cn(
          'min-h-[calc(100dvh-7.5rem)] bg-surface px-4 pb-24',
          'md:rounded-t-[2rem] md:border md:border-b-0 md:border-line md:px-6 md:pb-10 lg:min-h-[calc(100dvh-3.5rem)]',
          className,
        )}
      >
        {children}
      </div>
    </div>
  )
}
